var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBankTransfersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 37,
    viewBox: "0 0 50 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.72902 18.6978H1.0013V0.999897H33.9727V5.84863",
    stroke: "#1C1C1C",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.271 18.6978H48.9987V36.3956H16.0273V31.5469",
    stroke: "#1C1C1C",
    strokeWidth: 1.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6641 14.3335H36.8775",
    stroke: "#1C1C1C",
    strokeWidth: 1.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5312 11.0688L37.4041 14.3608L33.5312 17.6527",
    stroke: "#1C1C1C",
    strokeWidth: 1.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4062 23.6831L12.1929 23.6831",
    stroke: "#1C1C1C",
    strokeWidth: 1.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5391 26.9478L11.6662 23.6558L15.5391 20.3639",
    stroke: "#1C1C1C",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankTransfersIcon);
export default __webpack_public_path__ + "static/media/bank-transfers_icon.7dad3a9e2e494e96e500ff458d316c5a.svg";
export { ForwardRef as ReactComponent };